import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=6a588c59"
import script from "./HeaderNotifications.vue?vue&type=script&lang=ts"
export * from "./HeaderNotifications.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&id=6a588c59&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports